import { useState, useRef } from 'react';
import { useAppContext } from '../../context/AppContext';
import { importData } from '../../lib/exportImport';
import styles from './ImportModal.module.css';

export default function ImportModal() {
  const { state, dispatch } = useAppContext();
  const [mode, setMode]       = useState('merge');
  const [file, setFile]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const fileRef = useRef();

  function close() {
    dispatch({ type: 'CLOSE_MODAL' });
  }

  async function handleImport() {
    if (!file) { setError('Please choose a file'); return; }
    setError('');
    setLoading(true);
    try {
      const text = await file.text();
      await importData(text, mode, dispatch, state.activeHuntId);
      close();
    } catch (err) {
      setError(err.message || 'Import failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.backdrop} onClick={(e) => e.target === e.currentTarget && close()}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <h2 className={styles.title}>Import Collection</h2>
          <button className={styles.closeBtn} onClick={close} aria-label="Close">✕</button>
        </div>

        <div className={styles.body}>
          <p className={styles.hint}>
            Choose a previously exported <code>.json</code> file.
          </p>

          <button
            className={styles.fileBtn}
            onClick={() => fileRef.current?.click()}
          >
            {file ? file.name : 'Choose file…'}
          </button>
          <input
            ref={fileRef}
            type="file"
            accept="application/json,.json"
            className={styles.hiddenInput}
            onChange={e => { setFile(e.target.files[0] ?? null); setError(''); }}
          />

          <div className={styles.modeGroup}>
            <label className={`${styles.modeOption} ${mode === 'merge' ? styles.selected : ''}`}>
              <input
                type="radio"
                name="import-mode"
                value="merge"
                checked={mode === 'merge'}
                onChange={() => setMode('merge')}
                className={styles.hiddenInput}
              />
              <span className={styles.modeTitle}>Merge</span>
              <span className={styles.modeDesc}>Add new photos; keep existing ones. Overwrites only if the imported photo is newer.</span>
            </label>

            <label className={`${styles.modeOption} ${mode === 'replace' ? styles.selected : ''}`}>
              <input
                type="radio"
                name="import-mode"
                value="replace"
                checked={mode === 'replace'}
                onChange={() => setMode('replace')}
                className={styles.hiddenInput}
              />
              <span className={styles.modeTitle}>Replace</span>
              <span className={styles.modeDesc}>
                Delete all local data and replace with the imported file.
              </span>
            </label>
          </div>

          {error && <p className={styles.error}>{error}</p>}

          <div className={styles.actions}>
            <button className={styles.cancelBtn} onClick={close}>Cancel</button>
            <button className={styles.importBtn} onClick={handleImport} disabled={loading || !file}>
              {loading ? 'Importing…' : 'Import'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
